import apiClient from './apiClient';

export async function listPats() {
  return apiClient.get('pats');
}

export async function createPat(patData) {
  return apiClient.post('pats', patData);
}

export async function deletePat(patId) {
  return apiClient.delete(`pats/${patId}`);
}